var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_vm._m(0),_c('h2',{staticClass:"login-title"},[_vm._v("用户登录")]),_c('login-from')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-header"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png")}}),_c('span',[_vm._v("Express EDC 系统")])])
}]

export { render, staticRenderFns }